import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import useDevicesStore from 'store/devices';
import api from 'util/api';
import { Banner } from '@thermon-platforms/thermon-ui-core';
import { getDeviceUrl, isDuo } from 'util/device';
import { useNavigate } from 'react-router-dom';


function AssignDevice({device}) {
  const navigate = useNavigate();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [loading, setLoading] = useState();
  const [errors, setErrors] = useState();
  const [selectedParent, setSelectedParent] = useState('');
  const site = devicesStore.devices.find(device => device.type == 'Site');

  function assign() {
    setLoading(true);
    setErrors(undefined);

    api(`/devices/${selectedParent}/${device.model.id}/${(device.model.type || '').toLowerCase()}/assign`, { method: 'POST'})
      .then(async () => {
        await devicesStoreActions.query();
        const newDeviceModel = devicesStore.shallowDevices.get(device.model.id);
        navigate(getDeviceUrl(newDeviceModel) + (isDuo(newDeviceModel?.externalId) ? '' : '#network-settings'));
      })
      .catch(err => {
        setErrors(err);
      })
      .finally(() => {
        setLoading(false);
        setSelectedParent('');
      });
  }

  return (
    <div>
      <Banner status="alert" show={errors}>
        <Trans>An error occurred attempting to assign this device. Please, try again.</Trans>
      </Banner>
      <ul className="form">
        <li>
          <label htmlFor="select-parent"><Trans>Assign to:</Trans></label>
          <select
            id="select-parent"
            value={selectedParent}
            onChange={e => setSelectedParent(e.target.value)}
          >
            <option value={''}>
              <Trans>- Select parent -</Trans>
            </option>
            {site?.children.map(child => (
              <option value={child.id} key={`assign-device-${child.id}`}>
                {child.name}
              </option>
            ))}
          </select>
          <button
            className={`primary ${loading ? 'processing' : ''}`}
            disabled={!selectedParent || loading}
            onClick={assign}
          >
            <Trans>Assign</Trans>
          </button>
        </li>
      </ul>
    </div>
  );
}

export default AssignDevice;
